import { appActions } from '@app';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { GatewayContent } from './general';
import { jwtDecode } from 'jwt-decode';
import React from 'react';
import { setJWTToken } from '@sonar-software/sonar-ts-lib';
import { useAction, useOnMount } from '@hooks';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
export const AuthTokenRedirect = () => {
    const navigate = useNavigate();
    const { search } = useLocation();
    const { token } = useParams();
    const softReset = useAction(appActions.softResetApplication);
    useOnMount(() => {
        if (token) {
            const decodedToken = jwtDecode(token);
            if (decodedToken.userId && Date.now() < decodedToken.exp * 1000) {
                setJWTToken(token);
                softReset();
                setTimeout(() => {
                    navigate({
                        pathname: FULL_ROUTES.DASHBOARD,
                        search
                    }, { replace: true });
                }, 1000);
                return;
            }
            window.location.replace('/');
        }
    });
    return React.createElement(GatewayContent, null);
};
